import $ from 'jquery';
import ValidatedFormView from '../form/ValidatedFormView.js';
import {ValidatedAddressMixin} from '../form/ValidatedAddressMixin.mjs';
import '../form/FormControlHelp.mjs';
import '../form/FormUpload.mjs';

const FORM_PREFIX = 'tx_project_contestapplication[contestApplicationFormData]';

export class ContestApplicationForm extends ValidatedFormView {
  constructor(options) {
    let formValidations = {
      [`${FORM_PREFIX}[description]`]: ['required', {rule: 'maxLength', param: 250}],
      [`${FORM_PREFIX}[firstName]`]: ['required', 'forename'],
      [`${FORM_PREFIX}[lastName]`]: ['required', 'lastname'],
      [`${FORM_PREFIX}[street]`]: ['required', {'func': 'address1Rule'}],
      [`${FORM_PREFIX}[zip]`]: ['required', {'func': 'zipRule'}],
      [`${FORM_PREFIX}[city]`]: ['required', {'func': 'cityRule'}],
      [`${FORM_PREFIX}[phone]`]: ['optional', 'phone'],
      [`${FORM_PREFIX}[email]`]: ['required', 'email'],
      [`${FORM_PREFIX}[permissionForPublicationOfPhoto]`]: [{rule: 'checked', param: `${FORM_PREFIX}[permissionForPublicationOfPhoto]`}],
      [`${FORM_PREFIX}[conditionsOfParticipation]`]: [{rule: 'checked', param: `${FORM_PREFIX}[conditionsOfParticipation]`}],
      ['g-recaptcha-response']: ['required'],
    };

    const $formUploadAvailable = $( "#form-upload-available" );
    const isNotAnUploadedImageAvailable = $formUploadAvailable.length === 0;
    if (isNotAnUploadedImageAvailable) {
      formValidations[`${FORM_PREFIX}[image]`] = ['required'];
    }

    super(Object.assign({
      formName: 'contestApplicationFormData',
      validations: formValidations,
      liveValidations: {
        [`${FORM_PREFIX}[country]`]: {
          'change': [
            () => {
              this.validateField(`${FORM_PREFIX}[street]`, ['required', {'func': 'address1Rule'}]);
              this.validateField(`${FORM_PREFIX}[zip]`, ['required', {'func': 'zipRule'}]);
              this.validateField(`${FORM_PREFIX}[city]`, ['required', {'func': 'cityRule'}]);
            },
          ],
        },
      },
    }, options, ValidatedAddressMixin));

    // Expose validateField() to global scope for captcha required validation
    // @see packages/project/Resources/Private/Templates/Campaign/ContestApplication.html
    window.formContestApplicationValidateField = this.validateField.bind(this);

    this.scrollToErrorMessage();
  }

  doSubmit() {
    // Copy Recaptcha Response to TYPO3 model property
    const $recaptchaResponse = $('.g-recaptcha-response').first();
    const $recaptchaFormField = $('#js_form-input-recaptcha');
    $recaptchaFormField.val($recaptchaResponse.val());

    const userMailAddress = this.$form.find('#form-input-email').val();
    const hasNewsletterSubscriptionActivated = this.$form.find('#form-input-newsletterSubscription').prop('checked') || false;

    if (hasNewsletterSubscriptionActivated) {
      try {
        window.tC.event.newsletter({'user_mail': userMailAddress});
      } catch (e) {
        console.log('tC event newsletter failed with: ', e);
      }
    }

    // TYPO3 Submit
    super.doSubmit();
  }

}
